import React from "react";
import { Layout, Menu } from "antd";
import {
  ExperimentOutlined,
  HomeOutlined,
  DesktopOutlined,
  SettingOutlined,
  PictureOutlined,
  UnorderedListOutlined,
  TeamOutlined,
  HeartOutlined,
  TagsOutlined,
  ShopOutlined,
  ScheduleOutlined,
  CheckSquareOutlined,
  TrophyOutlined,
  WifiOutlined,
  CloudUploadOutlined,
  AreaChartOutlined,
  AndroidOutlined,
  ToolOutlined,
  ScanOutlined,
  FileExcelOutlined,
} from "@ant-design/icons";
import "../styles/Dashboard.css";
import { useNavigate } from "react-router-dom";
import { canManageUsers } from "../constants/roles";
import { useAuth } from "../context/AuthContext";

const { Sider } = Layout;

const SiderComponent = ({ selectedKey, setSelectedKey, collapsed, setCollapsed }) => {
  const navigate = useNavigate();
  const { role, isSupervisor, isHardwareAdmin } = useAuth();

  const items = [
    { key: "home", icon: <HomeOutlined />, label: "Home" },
    { key: "devices", icon: <DesktopOutlined />, label: "Devices" },
    { key: "discover", icon: <WifiOutlined />, label: "Find Cameras" },
    { key: "outlets", icon: <ShopOutlined />, label: "Outlets" },
    { key: "footfall", icon: <AreaChartOutlined />, label: "Footfall" },
    { key: "door-analytics", icon: <AreaChartOutlined />, label: "Door Analytics" },
    { key: "frame-quality", icon: <PictureOutlined />, label: "Frame Quality" },
    { key: "compliance-selections", icon: <TrophyOutlined />, label: "Compliance Selections" },
    { key: "selection-monitor", icon: <AreaChartOutlined />, label: "Selection Monitor" },
    { key: "detection-health", icon: <ScanOutlined />, label: "Detection Health" },
    { key: "threshold-bench", icon: <ExperimentOutlined />, label: "Threshold Bench" },
    ...(isHardwareAdmin
      ? [{ key: "model-bench", icon: <ExperimentOutlined />, label: "Model Bench" }]
      : []),
    // Open to any logged-in user, unlike the benches above: this one changes nothing — it reads
    // no setting and feeds no pipeline — and a diagnostic only admins can open is one the rest of
    // the team argues around instead of opening.
    { key: "sku-lab", icon: <ExperimentOutlined />, label: "SKU Lab" },
    { key: "health", icon: <HeartOutlined />, label: "Fleet Health" },
    ...(isHardwareAdmin
      ? [{ key: "reports", icon: <FileExcelOutlined />, label: "Reports" }]
      : []),
    { key: "tickets", icon: <TagsOutlined />, label: "Tickets" },
    { key: "visits", icon: <ScheduleOutlined />, label: "Visits" },
    ...(isSupervisor ? [{ key: "team", icon: <TrophyOutlined />, label: "Team" }] : []),
    ...(canManageUsers(role)
      ? [{ key: "checklist-templates", icon: <CheckSquareOutlined />, label: "Checklists" }]
      : []),
    { key: "configurations", icon: <SettingOutlined />, label: "Configurations" },
    ...(isHardwareAdmin
      ? [
          { key: "releases", icon: <CloudUploadOutlined />, label: "Releases" },
          { key: "mobile-app", icon: <AndroidOutlined />, label: "Mobile App" },
        ]
      : []),
    { key: "pictures", icon: <PictureOutlined />, label: "Pictures" },
    { key: "logs", icon: <UnorderedListOutlined />, label: "Logs" },
    ...(canManageUsers(role)
      ? [{ key: "users", icon: <TeamOutlined />, label: "Users" }]
      : []),
    // Fleet-wide configuration. Gated to hardwareAdmin+ because everything in here
    // changes how the whole fleet is reported, not just one device.
    ...(isHardwareAdmin
      ? [{ key: "settings", icon: <ToolOutlined />, label: "Settings" }]
      : []),
  ];

  return (
    <Sider
      width={210}
      className="dashboard-sider"
      collapsible
      collapsed={collapsed}
      onCollapse={setCollapsed}
      breakpoint="lg"
    >
      <Menu
        theme="dark"
        mode="inline"
        selectedKeys={[selectedKey]}
        items={items}
        onClick={(e) => {
          setSelectedKey(e.key);
          navigate(`/dashboard/${e.key}`);
        }}
        style={{ height: "100%", borderRight: 0, paddingTop: 16 }}
      />
    </Sider>
  );
};

export default SiderComponent;
